module.exports = __webpack_public_path__ + "img/qa_ssl.4822f216.svg";